'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

var _aos = require('aos');

var _aos2 = _interopRequireDefault(_aos);

var _node = require('./node');

var _node2 = _interopRequireDefault(_node);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = {
  hr: {
    height: '1950px',
    border: 'none',
    borderLeft: '2px solid #ddd',
    width: '1px',
    position: 'absolute',
    left: '364px',
    color: '#ddd',
    margin: 0,
    zIndex: -1,
    '@media (max-width: 767px)': {
      left: '19px',
      height: '1800px'
    }
  },
  wrapper: {
    position: 'relative',
    height: '2400px',
    '@media (max-width: 767px)': {
      width: '100%',
      height: '2130px',
      marginTop: '-50px',
      marginBottom: '30px'
    }
  }
};

var AnimatedList = function (_React$Component) {
  _inherits(AnimatedList, _React$Component);

  function AnimatedList(props) {
    _classCallCheck(this, AnimatedList);

    var _this = _possibleConstructorReturn(this, (AnimatedList.__proto__ || Object.getPrototypeOf(AnimatedList)).call(this, props));

    _this.state = {
      mobile: window.matchMedia("(max-width: 767px)").matches
    };

    _aos2["default"].init({
      easing: 'ease-out-back',
      duration: 1000,
      disable: _this.state.mobile
    });

    return _this;
  }

  _createClass(AnimatedList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var numberOfAnimations = document.querySelectorAll(".aos-animate").length;
      window.addEventListener('scroll', function (e) {
        if (numberOfAnimations !== document.querySelectorAll(".aos-animate").length) {
          numberOfAnimations = document.querySelectorAll(".aos-animate").length;

          _aos2["default"].refresh();
        }
      });
      window.addEventListener("resize", function () {
        if (window.matchMedia("(max-width: 767px)").matches) {
          _this2.setState({
            mobile: true
          });
        } else {
          _this2.setState({
            mobile: false
          }, function () {});
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return _react2["default"].createElement('div', {
        style: styles.wrapper
      }, _react2["default"].createElement('hr', {
        style: [styles.hr, this.props.customHrStyle]
      }), this.props.contents.map(function (content, i) {
        return _react2["default"].createElement(_node2["default"].component, {
          key: i,
          numberOfAnimations: _this3.state.numberOfAnimations,
          number: i + 1,
          title: content.title,
          paragraph: content.paragraph,
          imgUrl: content.imgUrl,
          mobile: _this3.state.mobile
        });
      }));
    }
  }]);

  return AnimatedList;
}(_react2["default"].Component);

var component = (0, _radium2["default"])(AnimatedList);
exports["default"] = {
  component: component
};